import classNames from "classnames";
import React, { FC } from "react";
import { CSS_CLASSES } from "./tab-css-classes";
import { TabPanelProps } from "./tab.types";
export const TabPanel: FC<TabPanelProps> = ({
  className: classNameProp,
  id,
  active,
  tabId,
  children,
  ...restProps
}) => {
  const className = classNames(
    {
      [CSS_CLASSES.TAB_PANEL_ACTIVE]: active,
    },
    classNameProp
  );
  return active ? (
    <div className={className} role="tabpanel" tabIndex={0} id={id} aria-labelledby={tabId} {...restProps}>
      {active ? children : null}
    </div>
  ) : null;
};
